import { render } from "./SelectedOrdersPopover.vue?vue&type=template&id=4c405ed3&scoped=true"
import script from "./SelectedOrdersPopover.vue?vue&type=script&lang=js"
export * from "./SelectedOrdersPopover.vue?vue&type=script&lang=js"

import "./SelectedOrdersPopover.vue?vue&type=style&index=0&id=4c405ed3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c405ed3"]])

export default __exports__